import { render } from "./MalawiChapterContent.vue?vue&type=template&id=bd05ee24&scoped=true&ts=true"
import script from "./MalawiChapterContent.vue?vue&type=script&lang=ts"
export * from "./MalawiChapterContent.vue?vue&type=script&lang=ts"

import "./MalawiChapterContent.vue?vue&type=style&index=0&id=bd05ee24&scoped=true&lang=css"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd05ee24"]])

export default __exports__